<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.manageUsers' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row">
        <a href="javascript:window.history.back();" class="btn btn-primary waves-effect waves-light btn-sm mb-3"><i class="mdi mdi-chevron-left ml-1"></i> {{'common.back' | translate}} </a>
        <ng-container *ngIf="form_validate">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{'users.editUser' | translate}}</h4>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.lastName' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="text" [(ngModel)]="single_client.name">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.firstName' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="text" [(ngModel)]="single_client.firstname">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.email' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="email" [(ngModel)]="single_client.email">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.company' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="text" [(ngModel)]="single_client.society">
                </div>
              </div>
              <div class="form-group row">
                <div class="input-group">
                  <label for="password" class="col-md-2 col-form-label">{{'fields.password' | translate}} :
                    <i class="bx bx-info-circle"
                       (mouseenter)="showInfo = true"
                       (mouseleave)="showInfo = false">
                    </i>
                    <div class="info-tooltip" *ngIf="showInfo">
                      {{'auth.passwordRules' | translate}}
                    </div>
                  </label>
                  <input type="password" name="password" id="password" #password1 class="col-md-10 form-control" style="margin-left: 12px;border-radius: 5px;" [placeholder]="'fields.password' | translate" value="" [(ngModel)]="single_client.password" [ngModelOptions]="{standalone: true}">
                  <div class="input-group-append" style="margin-right: 11px;border-radius: 5px !important;" (click)="changeType(password1, 1)">
                    <span class="input-group-text" ><i [ngClass]="toggle1 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                  </div>
                </div>
                <p class="font-italic mb-0">{{'messages.leavePasswordEmpty' | translate}}</p>
                <p *ngIf="isPasswordInvalid" class="text-danger fw-bold ml-2 mt-2">
                  {{'auth.passwordRules' | translate}}
                </p>
              </div>
              <div class="form-group row">
                <div class="input-group">
                  <label for="c_password" class="col-md-2 col-form-label">{{'fields.confirmation' | translate}} : </label>
                  <input type="password" name="c_password" id="c_password" #password2 class="col-md-10 form-control" style="margin-left: 12px;border-radius: 5px;" [attr.placeholder]="'auth.confirmPassword' | translate"  value="" [(ngModel)]="single_client.password_confirm" [ngModelOptions]="{standalone: true}">
                  <div class="input-group-append" style="margin-right: 11px;border-radius: 5px !important;" (click)="changeType(password2, 2)">
                    <span class="input-group-text"><i [ngClass]="toggle2 ? 'fa fa-eye' : 'fa fa-eye-slash'"></i></span>
                  </div>
                </div>
                <p class="font-italic">{{'messages.leaveConfirmationEmpty' | translate}}</p>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.username' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="text" [(ngModel)]="single_client.login" readonly>
                </div>
              </div>
              <div class="form-group text-center">
                <ng-container *ngIf="loadingAdd"><img src="assets/img/loaderkapi.gif" height="20"><br></ng-container>
                <button type="button" class="btn btn-primary waves-effect waves-light" (click)="update_client()">
                  {{'common.validate' | translate}}
                </button>
              </div>

            </div>
          </div>
        </div>
          </ng-container>

      </div>
      <!-- end row -->
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
  </div>
  <!-- End Page-content -->
  <app-footer></app-footer>
